<!-- Utiliza el ngFor para generar los elementos del submenú -->
<ul class="nav nav-sm flex-column">
  @for (subItem of subItems; track subItem) {
    <li class="nav-item">
      <!-- Si el subItem es visible, muestra el enlace del menú -->
      @if (checkMenuVisibility(subItem) && subItem.type === 'link') {
        <a routerLinkActive="active"
          [routerLink]="[subItem.path]" class="nav-link">
          {{ subItem.title }}
        </a>
      }
      <!-- Si el subItem es visible y tiene subItems, muestra el botón para colapsar/desplegar el submenú -->
      @if (checkMenuVisibility(subItem) && subItem.type === 'sub') {
        <a data-toggle="collapse" class="nav-link"
          (click)="subItem.isCollapsed = !subItem.isCollapsed" [attr.aria-expanded]="!subItem.isCollapsed"
          [attr.aria-controls]="getCollapseId(subItem)">
          {{ subItem.title }}
        </a>
      }
      <!-- Si el subItem es visible y tiene subItems, muestra el submenú recursivamente -->
      @if (checkMenuVisibility(subItem) && subItem.type === 'sub') {
        <div [collapse]="subItem.isCollapsed"
          [isAnimated]="true" [attr.aria-controls]="getCollapseId(subItem)">
          <app-submenu [subItems]="subItem.subItems" [rolesUsuario]="rolesUsuario"></app-submenu>
        </div>
      }
    </li>
  }
</ul>